import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div<{ clickable: boolean }>`
  display: flex;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  svg {
    transition: transform 0.2s;
  }
`;

export const DownIcon: React.FC<{
  className?: string;
  onClick?: () => void;
  fill?: string;
  rotate?: number;
  title?: string;
}> = ({ className, onClick, fill, rotate, title }) => {
  return (
    <StyledRoot clickable={!!onClick} title={title} className={className}>
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        onClick={onClick}
        transform={rotate ? `rotate(${rotate})` : undefined}
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={fill}
          d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
        />
      </svg>
    </StyledRoot>
  );
};
